import React, {useState} from 'react';
import {SearchBar, QuestionModal} from '@xpertdox_js/xdcomponents';
import axios from 'axios'
import axiosConfig from '../../config/axios.config';
import {UserContext} from '../../Context/UserContext';
import {InstanceContext} from '../../InstanceContext';
import styles from './styles';
import { trackError } from '../../utils/activityTracker';

const AddTrials = props => {
  const {type} = props;

  const {user, userAction} = React.useContext(UserContext)
  const {contextInstance} = React.useContext(InstanceContext);

  const [verifyModal, setVerifyModal] = useState(false)
  const [termToConfirm, setTermToConfirm] = useState(null)

  const mounted = React.useRef(true);
  React.useEffect(() => () => mounted.current = false, [])

  let instance = contextInstance || user.instance

  const handleSelect = (term, confirmModal) => {
    if(confirmModal) {
      let url = props.params.isPi
      ? `${axiosConfig.apiUrl}/rt/console/addPiTrial/${user.email}`
      : `${axiosConfig.apiUrl}/rt/savePriorityTrial/${contextInstance || user.instance}/newTrial/${user.email}`;


      let data = {trial: term._id}
      if (props.params.isPi) data.user = user;

      axios.post(url, data) // removed 'axiosConfig.auth' as token is updated on login
      .then(res => {
        props.refresh(type, true);
        props.controller.handlingUpdate = true;
        setTermToConfirm(null);
        props.handleDataRefresh();
      })
      .catch(err => {
        console.log("handleSelect err", err);
        trackError({ error: err, history: props.history })
        if(err && err.response && err.response.status === 403) {
          userAction({type: 'logout'})
        }
      })
    } else if (mounted.current) {
      setVerifyModal(true)
      setTermToConfirm(term)
    }
  }
 const confirmAddTrial = bool => {
   if (mounted.current) {
     if(bool) handleSelect(termToConfirm, bool)
     setVerifyModal(false)
   }
 }
 const acceptQuestion = () => confirmAddTrial(true);
 const declineQuestion = () => confirmAddTrial(false);

  return (
    <div style={styles.container}>
      <p style={styles.heading}>Search for studies to add to this list</p>
      <SearchBar
        {...props}
        axiosConfig={axiosConfig}
        context={props.location.state}
        addTrials={!props.params.isPi}
        index={`nct${instance.toLowerCase()}`}
        type="trials"
        selected={handleSelect}
        />
      {verifyModal &&
        <QuestionModal
          zIndex={1000}
          question={`Please confirm that you are the responsible personnel for the following study: ${termToConfirm._id}`}
          visible={verifyModal}
          acceptText='Confirm'
          declineText='Decline'
          acceptQuestion={acceptQuestion}
          declineQuestion={declineQuestion}
        />
      }

    </div>
  )
}

export default AddTrials
